import { createContext, use } from "react";

import type { TargetLang } from "@bindery/convex-retells/model/language";

export interface TargetLangContextValue {
  /** The reader's current global target language for gloss/translation. */
  targetLang: TargetLang;
  /** Update the target language and persist it to localStorage. */
  setTargetLang: (lang: TargetLang) => void;
}

export const TargetLangContext = createContext<TargetLangContextValue | null>(
  null,
);

/** Read the target-language context. Throws outside a `TargetLangProvider`. */
export function useTargetLang(): TargetLangContextValue {
  const ctx = use(TargetLangContext);
  if (!ctx) {
    throw new Error("useTargetLang must be used within a TargetLangProvider");
  }
  return ctx;
}
